<template>
    <div class="view view--login">
        <login />
    </div>
</template>

<script>
    import login from '../../components/Login.vue';

    export default {
        components: {
            login
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/Login.vue